module.exports = __webpack_public_path__ + "static/media/Young-Lady---Pastel.4be30a06.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/img/thumbnails/Young-Lady---Pastel.jpg
 ** module id = 451
 ** module chunks = 0
 **/